import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

// Profile
const UserProfile = lazy(() => import("../pages/Authentication/user-profile"));

// Authentication related pages
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Register = lazy(() => import("../pages/Authentication/Register"));
const ForgetPwd = lazy(() => import("../pages/Authentication/ForgetPassword"));
const HomePage = lazy(() => import("pages/Authentication/home"));
const AccountVerify = lazy(() => import("pages/Authentication/AccountVerify"));
const AccountLookup = lazy(() => import("pages/Authentication/AccountLookup"));

// Dashboard
const Dashboard = lazy(() => import("../pages/Dashboard/index"));
const SendersId = lazy(() => import("pages/Manage/SendersId"));
const Template = lazy(() => import("pages/Manage/Template"));
const Groups = lazy(() => import("pages/Manage/Groups"));
const ContactList = lazy(() => import("pages/Manage/Groups/GroupidTable"));
const QuickSms = lazy(() => import("pages/Sms/quicksms"));
const PersonalizedSms = lazy(() => import("pages/Sms/personalizedSms"));
const CustomizedSms = lazy(() => import("pages/Sms/customizedSms"));
const Verify = lazy(() => import("pages/Authentication/Verify"));
const ChangePassword = lazy(() => import("pages/Authentication/resetPassword"));
const SummeryReport = lazy(() => import("pages/Reports/summeryReport"));
const SenderSummaryReport = lazy(() => import("pages/Reports/senderSummary"));
// UNUSED (commented 2026-09-08): imported but never rendered in any route — pending deletion
// import DownloadReport from "pages/Reports/downloadReport";
const CampaignWiseReport = lazy(() => import("pages/Reports/campaignWiseReport"));
const ApiSmsReport = lazy(() => import("pages/Reports/apiSms"));
const ClickerReport = lazy(() => import("pages/Reports/clickerReport"));
const DetailedReport = lazy(() => import("pages/Reports/detailedReport"));
const ApiDetailedReport = lazy(() => import("pages/Reports/apidetailedReport"));
const ValidateTemplate = lazy(() => import("pages/Manage/ValidateTemplate"));
const Payments = lazy(() => import("pages/Accounts/payments"));
const Resellers = lazy(() => import("pages/Accounts/resellers"));
const Sales = lazy(() => import("pages/Accounts/sales"));
const UsersAccount = lazy(() => import("pages/Admin/users"));
const ResellersAccount = lazy(() => import("pages/Admin/resellers"));
const ContextNotes = lazy(() => import("pages/Admin/context-notes"));
// UNUSED (commented 2026-09-08): imported but never rendered in any route — pending deletion
// import PanelSms from "pages/Reports/panelSms";
const DeliveryReports = lazy(() => import("pages/Reports/deliveryReports"));
const NetworkGateWay = lazy(() => import("pages/Manage/networkGateWay"));

const AdminDltTemplate = lazy(() => import("pages/Admin/admindlttemplates"));
const Adminsenderid = lazy(() => import("pages/AdminManage/adminsenderid"));
const Admingroup = lazy(() => import("pages/Admin/admingroup"));
const Menus = lazy(() => import("pages/Admin/menus"));

const AdminQuickSms = lazy(() => import("pages/Admin/adminquickSms"));
const AdminPersonalizedSms = lazy(() => import("pages/Admin/adminpersonalizedsms"));
const AdminCustomizedSms = lazy(() => import("pages/Admin/admincustomizedsms"));
const AdminBulkSms = lazy(() => import("pages/Admin/adminbulksms"));
const ConformationPage = lazy(() => import("pages/Sms/ConformationPageQuickSms"));
const ConformationPagePersonalizedSms = lazy(() => import("pages/Sms/ConformationPagePersonalizedSms"));
const ConformationPageCustomizedSms = lazy(() => import("pages/Sms/customizedSms/ConfirmationCustomizedSms.js"));
// UNUSED (commented 2026-09-08): imported but never rendered in any route — pending deletion
// import ValidatePassword from "pages/Authentication/validatePassword";
const Purchases = lazy(() => import("pages/Accounts/purchases"));
const ScheduledReport = lazy(() => import("pages/Reports/scheduledReport"));
const ApiScheduledReport = lazy(() => import("pages/Reports/apischeduledReport"));
const BulkSms = lazy(() => import("pages/Sms/bulkSms"));
const Statistics = lazy(() => import("pages/Accounts/statistics"));
const Api = lazy(() => import("pages/Setting/api"));
const AdminDashboard = lazy(() => import("pages/AdminDashboard"));
const AdminViewModal = lazy(() => import("pages/Admin/users/viewUser"));
const AdminGateway = lazy(() => import("pages/AdminManage/adminGateway"));
const AdminSummeryReport = lazy(() => import("pages/AdminReport/AdminSummeryReport"));
const PurchaseTransactions = lazy(() => import("pages/Admin/purchase-transactions"));
const PaymentTransactions = lazy(() => import("pages/Admin/payment-transactions"));
const OtpSelection = lazy(() => import("pages/Authentication/otpSelection"));
const OtpVerificationPage = lazy(() => import("pages/Authentication/otpVerification"));
const SetPassword = lazy(() => import("pages/Authentication/SetPassword"));
const AdminPanelReport = lazy(() => import("pages/AdminReport/AdminPanelReport"));
const AdminDetailedReport = lazy(() => import("pages/AdminReport/AdminDetailedReport"));
const AdminApiMessages = lazy(() => import("pages/AdminReport/AdminApiMessages"));
const AdminApiSummary = lazy(() => import("pages/AdminReport/AdminApiSummary"));
const AdminScheduledReport = lazy(() => import("pages/AdminReport/AdminScheduledReport"));
const OutMessages = lazy(() => import("pages/AdminReport/OutMessages"));
const AdminValidateTemplate = lazy(() => import("pages/Admin/adminvalidatetemplate"));
const AdminConformationPagePersonalizedSms = lazy(() => import("pages/Admin/confirmationpage/adminpersonalize"));
const AdminConformationPageCustomizedSms = lazy(() => import("pages/Admin/confirmationpage/admincustomized"));
const IpWhitelisting = lazy(() => import("pages/Setting/ip-whitelisting"));
const BlocklistNumbers = lazy(() => import("pages/Setting/blocklist-numbers"));
const WhitelistNumbers = lazy(() => import("pages/Setting/whitelist-numbers"));

// Payment Pages
const PaymentPage = lazy(() => import("pages/Payment"));
const PaymentSuccess = lazy(() => import("pages/PaymentSuccess"));
const PaymentLinks = lazy(() => import("pages/Admin/payment-links"));

//Reseller Pages
const ManageClients = lazy(() => import("pages/Reseller/ManageClients"));
const ResellerSummaryReport = lazy(() => import("pages/Reseller/Reports/resller-summary"));
const ResellerCampaignWiseReport = lazy(() => import("pages/Reseller/Reports/campaign-detailed"));
const ResellerDashboard = lazy(() => import("pages/Reseller/ResellerDashboard"));
const CreditsTransfer = lazy(() => import("pages/Reseller/CreditsTransfer"));

//Billing Pages
const UserMetrics = lazy(() => import("pages/AdminReport/Adminbilling/usermetrics"));
const DlrStatusSummary = lazy(() => import("pages/AdminReport/Adminbilling/dlrStatusSummary"));

// CRM Pages
const CrmDashboard = lazy(() => import("pages/Crm/dashboard"));
const CrmCustomers = lazy(() => import("pages/Crm/customers"));
const CrmCategories = lazy(() => import("pages/Crm/categories"));
const CrmPurchases = lazy(() => import("pages/Crm/purchases"));
const CrmPayments = lazy(() => import("pages/Crm/payments"));
const CrmLedger = lazy(() => import("pages/Crm/ledger"));

// ReportsV2 Pages
const CampaignReports = lazy(() => import("pages/ReportsV2").then((m) => ({ default: m.CampaignReports })));
const ScheduledCampaignReports = lazy(() => import("pages/ReportsV2").then((m) => ({ default: m.ScheduledCampaignReports })));
const DetailedSearchReport = lazy(() => import("pages/ReportsV2").then((m) => ({ default: m.DetailedSearchReport })));

const AdminCampaignReports = lazy(() => import("pages/AdminReportsV2").then((m) => ({ default: m.AdminCampaignReports })));
const AdminScheduledReports = lazy(() => import("pages/AdminReportsV2").then((m) => ({ default: m.AdminScheduledReports })));
const AdminDetailedSearchReport = lazy(() => import("pages/AdminReportsV2").then((m) => ({ default: m.AdminDetailedSearchReport })));

// WhatsApp Pages
const WhatsAppTemplates = lazy(() => import("pages/WhatsApp/templates"));

// RCS Pages
const RCSTemplates = lazy(() => import("pages/RCS/templates"));
const RCSCampaigns = lazy(() => import("pages/RCS/campaigns"));

// Base routes that are available to all authenticated users
const baseRoutes = [
  { path: "/profile", component: <UserProfile /> },
  { path: "/dashboard", component: <Dashboard /> },

  { path: "/Manage/Sendersid", component: <SendersId /> },
  { path: "/Manage/Template", component: <Template /> },
  { path: "/Manage/Groups", component: <Groups /> },
  { path: "/Manage/Groups/GroupidTable/:id", component: <ContactList /> },
  { path: "/Manage/ValidateTemplate", component: <ValidateTemplate /> },
  { path: "/Manage/networkGateWay", component: <NetworkGateWay /> },

  { path: "/Sms/quicksms", component: <QuickSms /> },
  { path: "/Sms/personalizedSms", component: <PersonalizedSms /> },
  { path: "/Sms/customizedSms", component: <CustomizedSms /> },
  { path: "/Sms/ConformationPageQuickSms", component: <ConformationPage /> },
  { path: "Sms/ConformationPagePersonalizedSms", component: <ConformationPagePersonalizedSms /> },
  { path: "/Sms/customizedSms/confirmation", component: <ConformationPageCustomizedSms /> },
  { path: "/Sms/bulkSms", component: <BulkSms /> },

  { path: "/Reports/summaryReport", component: <SummeryReport /> },
  { path: "/Reports/senderSummaryReport", component: <SenderSummaryReport /> },
  { path: "/Reports/campaignWiseReport", component: <CampaignWiseReport /> },
  { path: "/Reports/apiSmsReport", component: <ApiSmsReport /> },
  { path: "/Reports/short-url-summary", component: <ClickerReport /> },
  { path: "/Reports/detailedReport", component: <DetailedReport /> },
  { path: "/Reports/apiDetailedReport", component: <ApiDetailedReport /> },
  { path: "/Reports/diliveryReports", component: <DeliveryReports /> },
  { path: "Reports/scheduledReport", component: <ScheduledReport /> },
  { path: "/Reports/apiScheduledReport", component: <ApiScheduledReport /> },

  // ReportsV2 Routes
  { path: "/ReportsV2/campaigns", component: <CampaignReports /> },
  { path: "/ReportsV2/scheduled-campaigns", component: <ScheduledCampaignReports /> },
  { path: "/ReportsV2/detailed-search", component: <DetailedSearchReport /> },
  { path: "/ReportsV2/admin-campaign-reports", component: <AdminCampaignReports /> },
  { path: "/ReportsV2/admin-scheduled-campaigns", component: <AdminScheduledReports /> },
  { path: "/ReportsV2/admin-detailed-report", component: <AdminDetailedSearchReport /> },

  { path: "/Accounts/payments", component: <Payments /> },
  { path: "/Accounts/resellers", component: <Resellers /> },
  { path: "/Accounts/sales", component: <Sales /> },
  { path: "/Accounts/purchases", component: <Purchases /> },
  { path: "/Accounts/statistics", component: <Statistics /> },

  { path: "/Setting/api", component: <Api /> },
  { path: "/Setting/ip-whitelisting", component: <IpWhitelisting /> },
  { path: "/Setting/blocklist-numbers", component: <BlocklistNumbers /> },
  { path: "/Setting/whitelist-numbers", component: <WhitelistNumbers /> },
  { path: "/reset-password", component: <ChangePassword /> },

  // WhatsApp Routes
  { path: "/WhatsApp/templates", component: <WhatsAppTemplates /> },

  // RCS Routes
  { path: "/RCS/templates", component: <RCSTemplates /> },
  { path: "/RCS/campaigns", component: <RCSCampaigns /> },
];

// Reseller-specific routes
const resellerRoutes = [
  { path: "/Reseller/ManageClients", component: <ManageClients /> },
  { path: "/Reseller/reports/Summary", component: <ResellerSummaryReport /> },
  { path: "/Reseller/reports/detailed", component: <ResellerCampaignWiseReport /> },
  { path: "/Reseller/dashboard", component: <ResellerDashboard/> },
  { path: "/Reseller/credits-transfer", component: <CreditsTransfer /> },
];

// Admin-specific routes
const adminRoutes = [
  { path: "/Admin/admindlttemplates", component: <AdminDltTemplate /> },
  { path: "/Admin/admingroup", component: <Admingroup /> },
  { path: "/Admin/adminquickSms", component: <AdminQuickSms /> },
  { path: "/Admin/adminpersonalizedsms", component: <AdminPersonalizedSms /> },
  { path: "/Admin/admincustomizedsms", component: <AdminCustomizedSms /> },
  { path: "/Admin/adminbulksms", component: <AdminBulkSms /> },
  { path: "/Admin/users", component: <UsersAccount /> },
  { path: "/Admin/users/viewUser", component: <AdminViewModal /> },
  { path: "/Admin/resellers", component: <ResellersAccount /> },
  { path: "/Admin/context-notes", component: <ContextNotes /> },
  { path: "/Admin/menus", component: <Menus /> },
  { path: "/AdminDashboard", component: <AdminDashboard /> },
  { path: "/AdminManage/adminsenderid", component: <Adminsenderid /> },
  { path: "/AdminManage/adminGateway", component: <AdminGateway /> },
  { path: "/AdminReport/AdminSummeryReport", component: <AdminSummeryReport /> },
  { path: "/Admin/purchase-transactions", component: <PurchaseTransactions /> },
  { path: "/Admin/payment-transactions", component: <PaymentTransactions /> },
  { path: "/AdminReport/AdminPanelReport", component: <AdminPanelReport /> },
  { path: "/AdminReport/AdminDetailedReport", component: <AdminDetailedReport /> },
  { path: "/AdminReport/AdminApiMessages", component: <AdminApiMessages /> },
  { path: "/AdminReport/AdminApiSummary", component: <AdminApiSummary /> },
  { path: "/AdminReport/AdminScheduledReport", component: <AdminScheduledReport /> },
  { path: "/AdminReport/OutMessages", component: <OutMessages /> },
  { path: "/Admin/payment-links", component: <PaymentLinks /> },
  { path: "/Admin/validatetemplate", component: <AdminValidateTemplate /> },
  { path: "/Admin/adminpersonalizedsms/confirmation", component: <AdminConformationPagePersonalizedSms /> },
  { path: "/Admin/admincustomizedsms/confirmation", component: <AdminConformationPageCustomizedSms /> },
  { path: "/AdminReport/Adminbilling/usermetrics", component: <UserMetrics /> },
  { path: "/AdminReport/Adminbilling/dlr-status-summary", component: <DlrStatusSummary /> },

  // CRM Routes
  { path: "/crm/dashboard", component: <CrmDashboard /> },
  { path: "/crm/customers", component: <CrmCustomers /> },
  { path: "/crm/categories", component: <CrmCategories /> },
  { path: "/crm/purchases", component: <CrmPurchases /> },
  { path: "/crm/payments", component: <CrmPayments /> },
  { path: "/crm/ledger", component: <CrmLedger /> },
];

// Function to get current user role
const getCurrentUserRole = () => {
  return sessionStorage.getItem("roleName") || "USER";
};

// Function to generate routes based on user role
export const generateAuthProtectedRoutes = () => {
  const roleName = getCurrentUserRole();
  
  let routes = [...baseRoutes];

  if (roleName === "RESELLER") {
    routes = [...routes, ...resellerRoutes];
  }

  if (roleName === "ADMIN") {
    routes = [...routes, ...adminRoutes];
  }

  // Add default route at the end
  routes.push({
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  });

  return routes;
};

// Generate initial routes (this will be updated when user logs in)
const authProtectedRoutes = generateAuthProtectedRoutes();

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/verify", component: <Verify /> },
  { path: "/otpSelection", component: <OtpSelection /> },
  { path: "/otpVerificationPage", component: <OtpVerificationPage /> },
  { path: "/set-password", component: <SetPassword /> },
  { path: "/home", component: <HomePage /> },
  { path: "/account-verify", component: <AccountVerify /> },
  { path: "/account-lookup", component: <AccountLookup /> },
  { path: "/payment/:linkId", component: <PaymentPage /> },
  { path: "/payment-success", component: <PaymentSuccess /> },
];

export { authProtectedRoutes, publicRoutes };